// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"177":"home","216":"forbidden","357":"unauthorized","523":"shop","571":"settings"}[chunkId] || chunkId) + "-legacy." + {"177":"813c4909","178":"a9b7e3b9","216":"654b9d10","357":"e6f5a4f8","523":"e5d028f8","571":"891724b8"}[chunkId] + ".js";
};